import { render, staticRenderFns } from "./BuildingsDetailEdit.vue?vue&type=template&id=b2043982&scoped=true&"
import script from "./BuildingsDetailEdit.vue?vue&type=script&lang=ts&"
export * from "./BuildingsDetailEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2043982",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2043982')) {
      api.createRecord('b2043982', component.options)
    } else {
      api.reload('b2043982', component.options)
    }
    module.hot.accept("./BuildingsDetailEdit.vue?vue&type=template&id=b2043982&scoped=true&", function () {
      api.rerender('b2043982', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/buildings/BuildingsDetailEdit.vue"
export default component.exports